<div class='ui-float-label'>
  <label for='bank'>{{'fwl.bank' | translate}}</label>
  <input (change)='validateNewBankAccount()' [(ngModel)]='bankAccount.bank' id='bank' pInputText required class='d-flex col-12' data-testid="bank-input"/>
</div>
<div class='ui-float-label'>
  <label for='account'>{{'fwl.account' | translate}}</label>
  <input (change)='validateNewBankAccount()' [(ngModel)]='bankAccount.account' id='account' pInputText required class='d-flex col-12' data-testid="account-input"/>
</div>
<ng-template pTemplate="footer">
  <div class='ui-dialog-buttonpane ui-helper-clearfix'>
    <button (click)='clearNewAccount()' icon='fa-solid fa-xmark' pButton type='button' data-testid="clear-new-account-btn"></button>
    <button (click)='saveNewAccount()' [disabled]='!bankAccountIsValid' icon='ui-icon-check' pButton
            type='button' data-testid="save-new-account-btn"></button>
  </div>
</ng-template>
